/// <reference path="../app.ts" />
namespace Cfnc {
    interface ITranscriptMessageModalScope extends ng.IScope {
        close;
    }

    interface ITranscriptMessageModal {
        
    }

    class TranscriptMessageModal implements ITranscriptMessageModal {
        static controllerId: string = "transcriptMessageModal";
       
        constructor(private $uibModalInstance: ng.ui.bootstrap.IModalServiceInstance, private common: ICommonFactory, private $scope:ITranscriptMessageModalScope) {
            $scope.close = () => this.close();
        }

        close() {
            this.$uibModalInstance.dismiss();
        }
    }

    angular.module("app").controller(TranscriptMessageModal.controllerId, ["$uibModalInstance", "common", "$scope", ($uibModalInstance: ng.ui.bootstrap.IModalServiceInstance, common: ICommonFactory, $scope) =>
        new TranscriptMessageModal($uibModalInstance, common, $scope)
    ]);

}
